import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RastreioComponent } from './rastreio.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { MdModule } from '../md/md.module';
import { MaterialModule } from '../material.module';
import { TextMaskModule } from 'angular2-text-mask';
import { NgBrazil } from 'ng-brazil';
import { NgSelectModule } from '@ng-select/ng-select';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ClipboardModule } from 'ngx-clipboard';
import { MatButtonModule, MatButtonToggleModule, MatCardModule, MatIconModule } from '@angular/material';
import { DirectivesModule } from '../directives/directives.module';

export let options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
  declarations: [RastreioComponent],
  exports: [RastreioComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdModule,
    MaterialModule,
    TextMaskModule,
    NgBrazil,
    NgSelectModule,
    NgxMaskModule.forRoot(options),
    CurrencyMaskModule,
    NgxSpinnerModule,
    NgxChartsModule,
    NgxExtendedPdfViewerModule,
    LazyLoadImageModule,
    ClipboardModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    DirectivesModule,
  ],
})
export class RastreioModule {}
